import {defineStore} from 'pinia'
import {readonly, ref} from 'vue'
import type {ActiveCore} from '@/common/services/ActiveCore/ActiveCoreService'

export const useActiveCoreStore = defineStore('ACTIVE_CORE', () => {
  const activeCore = ref<ActiveCore | null>(null)
  const setActiveCore = (core: ActiveCore | null) => {
    activeCore.value = core
  }

  return {
    activeCore: readonly(activeCore),
    setActiveCore
  }
})
